import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { component, css, styled } from './component';
import { db, initDb, initLocalDb } from './db';
import { X, XInit, XObject } from './XObject';
import Sugar from 'sugar';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
  useParams,
  useNavigation,
  useNavigate,
} from "react-router-dom";
import { PropertyField } from './components/PropertyField';
import { FileUpload, uploadedFileUrl } from './components/FileUpload';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import juration from './juration';
import classNames from 'classnames';
import _ from 'lodash';
import axios from 'axios';
import { Sparklines, SparklinesLine, SparklinesReferenceLine } from 'react-sparklines';
import copy from 'copy-to-clipboard';
import { genPromp1, genPrompt2 } from './prompt';
import clipboard from 'clipboardy';
import config from './config';

function formatNumber(num) {
  return Math.round(num * 10) / 10;

}

function didThisShowEndWell(tvShow) {
  if (tvShow.unclearAnswer) return 'Maybe';
  return tvShow.generalConsensusRating < .6 ? 'No' : 'Yes'
}


// parseFloat(($$('.sc-577bf7cb-0 .ipc-rating-star--imdb').map(el => parseFloat(el.textContent)).reduce((a, c) => a + c, 0)/12 /10).toFixed(2))

@component
class Media extends Component<{ value, setValue }> {
  static styles = styled.div`
    height: 100%;
    > div {
      height: 100%;
    }
    img {
      height: 30px;
      display: block;
    }
  `;
  render() {
    return (
      <FileUpload
        onUpload={async (file) => {
          this.props.setValue(file);
        }}
      >
        <img src={uploadedFileUrl(this.props.value)} />
      </FileUpload>

    )
  }
}

const user = '6531a1f68304badf1c673f24';

Sugar.extend();

enum ReviewSite {
  imdb = 'ba0597d0-a6bc-5589-b860-3beb98a154e2',
  rottenTomatoes = 'd822a304-f8b1-58be-a069-83d65784367d',
  metacritic = 'e29ad7ae-6d1b-57f1-853f-de3d4ada2eab',
  tmdb = 'b3dfc71d-b5c2-5d4d-9dae-872aa6a968df',
}

const reviewSites = [
  {
    _id: ReviewSite.imdb,
    name: 'IMDb',
    search: query => {
      return `https://www.imdb.com/find/?s=tt&exact=true&q=${query}`;
    },

  },
  {
    _id: ReviewSite.rottenTomatoes,
    name: 'Rotten Tomatoes',
    usesAverage: true,
  },
  {
    _id: ReviewSite.metacritic,
    name: 'Metacritic',
  },
  {
    _id: ReviewSite.tmdb,
    name: 'TMDb',
    search: query => {
      return `https://www.themoviedb.org/search/tv?query=${query}`;
    },
  }
]

const reviewSources = [
  {
    _id: 'a7a0e2c2-0c38-581c-9b2d-c1e5c06aae61',
    site: ReviewSite.imdb,
    name: 'IMDb',
    shortName: 'IMDb',
    slug: 'imdb',
  },
  {
    _id: 'b28fe9fc-c822-570a-b325-92fd43503a35',
    site: ReviewSite.rottenTomatoes,
    name: 'Rotten Tomatoes (Critics)',
    shortName: 'RT (C)',
    slug: 'rtC',
  },
  {
    _id: '32a00185-3175-5003-b63e-acb7a5fd955e',
    site: ReviewSite.rottenTomatoes,
    name: 'Rotten Tomatoes (Audience)',
    shortName: 'RT (A)',
    slug: 'rtA',
  },

  {
    _id: 'ea0ead45-bc58-5866-9483-d06cfa025987',
    site: ReviewSite.metacritic,
    name: 'Metacritic (Metascore)',
    shortName: 'MT (M)',
    slug: 'mtM',
  },

  {
    _id: 'de4d47e9-1841-5367-a375-4438516e0328',
    site: ReviewSite.metacritic,
    name: 'Metacritic (User Score)',
    shortName: 'MT (U)',
    slug: 'mtU',
  },
  {
    _id: '85a9bcb3-659f-54c3-a206-4d33ef9f05bb',
    site: ReviewSite.tmdb,
    name: 'TMDb',
    shortName: 'TMDb',
    slug: 'tmdb',
  },
]


@component
class Admin_TvShows extends Component<{ navigate }> {
  static styles = styled.div`
    .canceled {
      text-decoration: line-through;
    }
  `;

  state = XInit(class {
    tab = 'reviewed'
  })
  render() {
    const add = () => {
      const tvShow = XObject.obj({
        name: 'New TV Show',
        generalConsensusRating: 0,
        scrape: true,
      });
      db.tvShows.push(tvShow);

      this.props.navigate(`/admin/tv-shows/${tvShow._id}`);

    }



    let tvShows = [...db.tvShows];
    if (this.state.tab == 'notReviewed') {
      tvShows = tvShows.filter(x => !x.generalConsensus);
      if (0) {
        tvShows.sort((a, b) => {
          if (!a.generalConsensusRating && !b.generalConsensusRating) return 0;
          if (!a.generalConsensusRating) return 1;
          if (!b.generalConsensusRating) return -1;
          return b.generalConsensusRating - a.generalConsensusRating;
        })
    
      }
      else {
        tvShows.sort((a, b) => {
          if (!a.endDate && !b.endDate) return 0;
          if (!a.endDate) return 1;
          if (!b.endDate) return -1;
  
          return b.endDate.getTime() - a.endDate.getTime();
  
        });
      }  
    }
    else if (this.state.tab == 'reviewed') {
      tvShows = tvShows.filter(x => x.generalConsensus);
    }


    return (

      
      <>

        <div>
          <span onClick={() => this.state.tab = 'reviewed'}>Reviewed</span> <span onClick={() => this.state.tab = 'notReviewed'}>Not Reviewed</span>
        </div>
        {/* <ul>
          {db.tvShows.map(tvShow => {
            return <li key={tvShow._id}>
              <Link to={`/admin/tv-shows/${tvShow._id}`}>{tvShow.name}</Link> <Link target="_blank" to={`/${tvShow.slug}`}>({tvShow.generalConsensusRating})</Link>
            </li>
          })}
          <li>

          </li>
        </ul> */}

        {db.tvShows.length} ({db.tvShows.filter(x => x.generalConsensus).length})

          <button
              onClick={() => {
                add();
                
              }}
            >+</button>


              <button
                onClick={() => {
                  for (const tvShow of db.tvShows) {
                    tvShow.averageRating = tvShow.seasons && averageRating(tvShow);
                  }
                }}
              >Update</button>
              <button
                onClick={async () => {
                  await axios.get(`${config.apiServer}publish-data`);
                }}
              >Publish to S3</button>
        <table border={1}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Rating</th>
              <th>Start</th>
              <th>End</th>
              <th>Seasons</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {tvShows.map(tvShow => {
              return <tr key={tvShow._id}>
                <td className={classNames({ canceled: tvShow.canceled })}>
                <Link to={`/admin/tv-shows/${tvShow._id}`}>{tvShow.name}</Link>
                </td>
                <td>
                  {tvShow.generalConsensusRating} • {formatNumber(tvShow.averageRating*10)}
                </td>
                <td>{tvShow.startDate?.format?.('{yyyy}-{MM}-{dd}')}</td>
                <td>{tvShow.endDate?.format?.('{yyyy}-{MM}-{dd}')}</td>
                <td>{tvShow.seasons?.length}</td>
                <td><button
                  onClick={() => {
                    const index = db.tvShows.indexOf(tvShow);
                    db.tvShows.splice(index, 1);
                  }}
                >X</button></td>

              </tr>
            })}

          </tbody>
        </table>

        <button
              onClick={() => {
                add();
                
              }}
            >+</button>
      </>
    )
  }
}

@component
class Footer extends Component {
  static styles = styled.div`
    display: flex;
    max-width: 880px;
    margin: 16px auto 8px;
    font-size: 10px;
    padding-bottom: 32px;
    color: gray;
    

    @media (max-width: calc(879px + 16px*2)) {

      padding-left: 16px;
      padding-right: 16px;
    }

  `;
  render() {
    return (
      <>
      © 2023 doesthisshowendwell.com. All Rights Reserved.

      </>
    )
  }
}

@component
class Header extends Component<{ name? }> {
  static styles = styled.div`
    display: flex;
    max-width: 880px;
    margin: 0 auto 8px;

    @media (max-width: calc(879px + 16px*2)) {

      padding-left: 16px;
      padding-right: 16px;
    }

    .logo {
      margin-left: -16px;
      width: 70px;
      height: 70px;
      /* background-size: ; */
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    .name {
      font-size: 26px;
    }
    align-items: center;

    @media (max-width: 400px) {
      .name {
        font-size: 18px;
      }
    }
  `;
  render() {
    return (
      <>
        <span className="logo"
          style={{
            backgroundImage: `url(${require('./images/logo.svg').default})`
          }}
        />
        <span className="name">Does {this.props.name || 'This Show'} End Well?</span>
      </>
    )
  }
}

const ratingColors = [
  { background: '#8b0000', text: 'white' },
  { background: '#9b111e', text: 'white' },
  { background: '#b22222', text: 'white' },
  { background: '#d9534f', text: 'black' },
  { background: '#ff7f50', text: 'black' },
  { background: '#ffa07a', text: 'black' },
  { background: '#f0e68c', text: 'black' },
  { background: '#98fb98', text: 'black' },
  { background: '#32cd32', text: 'black' },
  { background: '#2e8b57', text: 'white' },
  { background: '#008000', text: 'white' }
];

const styles = css`

  .genConsensusRating {
          font-size: 12px;
          background-color: red;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          text-align: center;
          border-radius: 50%;
          color: white;
        }

        .genConsensusRating.r-0 {
            background-color: #8b0000; /* Dark Red */
            color: white;
        }

        .genConsensusRating.r-1 {
            background-color: #9b111e; /* Red Devil */
            color: white;
        }

        .genConsensusRating.r-2 {
            background-color: #b22222; /* Firebrick */
            color: white;
        }

        .genConsensusRating.r-3 {
            background-color: #d9534f; /* Light Coral */
            color: black;
        }

        .genConsensusRating.r-4 {
            background-color: #ff7f50; /* Coral */
            color: black;
        }

        .genConsensusRating.r-5 {
            background-color: #ffa07a; /* Light Salmon */
            color: black;
        }

        .genConsensusRating.r-6 {
            background-color: #f0e68c; /* Khaki */
            color: black;
        }

        .genConsensusRating.r-7 {
            background-color: #98fb98; /* Pale Green */
            color: black;
        }

        .genConsensusRating.r-8 {
            background-color: #32cd32; /* Lime Green */
            color: black;
        }

        .genConsensusRating.r-9 {
            background-color: #2e8b57; /* Sea Green */
            color: white;
        }

        .genConsensusRating.r-10 {
            background-color: #008000; /* Green */
            color: white;
        }

`;

function seasonAverages(tvShow) {
  const data = [];
  if (tvShow.seasons) for (const s of tvShow.seasons) {
    const values = [];
    for (const reviewSite of reviewSources) {
      const d = s.webReviews[reviewSite._id];
      if (d?.rating) {
        values.push(d.rating);
      }
    }

    let total = 0;
    for (const v of values) total += v;

    data.push(total/values.length);


  }

  return data;
}

@component
class TvShowSparkline extends Component <{ tvShow }> {
  static styles = styled.div`
    background-color: #f8f8f8;
    border-radius: 4px;
    overflow: hidden;
    svg {
      margin: 0;
      display: block;
    }
  `;
  render() {
    const data = seasonAverages(this.props.tvShow).map(x => x*10);
    if (data.length == 1) {
      data.push(data[0])
    }
    return           <Sparklines 
    min={0}
    max={10}
    margin={0}
      data={data}
      // data={[8, 14, 10, 5]}
  >
<SparklinesLine />
{/* <SparklinesReferenceLine type="mean" /> */}
</Sparklines>
  }
}

@component
class TvShow extends Component<{ slug }> {
  static styles = styled.div`

    .cont {
      max-width: 880px;
      margin: 0 auto;

      @media (max-width: calc(879px + 16px*2)) {

        padding-left: 16px;
        padding-right: 16px;
      }

    }




    .body-top {



      min-height: 246px;
      margin: 0 auto 36px;
      position: relative;
      padding-left: calc(166px + 16px);
      box-sizing: border-box;


      .info {
        > .name {
          > .rating {
            font-size: 13px;
            margin-top: 5px;
            margin-left: 4px;
            &:before {
              content: ' • ';
            }
          }
        }
      }

      .poster {
        display: block;
        width: 166px;
        height: 246px;
        background-size: contain;
        background-position: center;
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 4px;
        overflow: hidden;
      }

      @media (max-width: 637px) {
        padding-left: 0;
        .poster {
          display: none;
        }
      }

      .name {
        &.canceled .theName {
          text-decoration: line-through;
        }
        font-size: 30px;
        display: flex;
        align-items: center;
        .genConsensusRating {
          margin-left: 8px;
          margin-top: 5px;
        }
      }


      .stats {
        /* margin-bottom: 8px; */
        font-size: 12px;
      }

      ${styles}

      .generalConsensus {
        border: 2px solid black;
        padding: 8px;
        margin: 8px 0;
        border-radius: 4px;

      }

      .answer {
        margin: 0 0 0;
        font-size: 20px;
        display: block;
        font-weight: bold;
      }



      .generalConsensusText {
        /* margin: 24px 0; */
        margin-bottom: 0;
        font-weight: 500;
        font-size: 14px;




      }

      .webReviews {
        display: flex;
        gap: 16px;
        .webReview {
          text-decoration: none;
          color: inherit;
          .site {
            display: block;
            font-weight: 600;
            font-size: 13px;
          }

          .rating {
            font-size: 13px;
          }
        }
      }
    }
    .body-bottom {

    }
  `;
  componentDidMount(): void {
    const tvShow = db.tvShows.find(x => x.slug == this.props.slug);

    document.title = `Did ${tvShow.name} End Well?`;
  }
  render() {
    const tvShow = db.tvShows.find(x => x.slug == this.props.slug);
    const categories = [];

    for (const s of tvShow.seasons) {
      categories.push('S' + s.number);
    }
    
    const series = [];
    if (1) {
      const data = seasonAverages(tvShow).map(v => formatNumber(v*10));
      series.push({
        name: 'Average',
        data,
        dataLabels: {
          enabled: true,
          inside: false, // set to true if you want the label inside the bar
          // format: '{y}', // {y} will be replaced by the value
        }
      });
    }

    if (1) {
      for (const reviewSite of reviewSources) {
        const data = [];
        for (const s of tvShow.seasons) {
          const d = s.webReviews[reviewSite._id];
          if (d) {
            data.push(formatNumber(d.rating * 10));
          }
          else {
            data.push(null);
          }
        }
        series.push({
          name: reviewSite.name,
          data,
          dataLabels: {
            enabled: true,
            inside: false, // set to true if you want the label inside the bar
            formatter: function() {
              return this['y'] === 0 ? null : this['y']; // Hide label for zero value
          }

        }

        })
      }
  
    }

    let totalEps = 0;
    for (const s of tvShow.seasons) {
      totalEps += s.numEpisodes;
    }
    const r = Math.round(tvShow.generalConsensusRating*10);
    return (
      <>
        <Header/>
        <div className="cont">
          <div className="body-top">
            <span className="poster" style={{ backgroundImage: `url(${uploadedFileUrl(tvShow.poster)})`}} />
            <div className="info">
              <div className={classNames('name', {
                canceled: tvShow.canceled,
              })}>
                <span className="theName">{tvShow.name}</span>
                <span className={classNames('genConsensusRating', `r-${Math.round(tvShow.generalConsensusRating*10)}`)}>{tvShow.generalConsensusRating*10}</span>
                <span className="rating">{formatNumber(averageRating(tvShow)*10)}</span>
              </div>
              <div className="stats">
                {tvShow.startDate.format('{yyyy}')}-{tvShow.endDate.format('{yyyy}')} • {tvShow.seasons.length} seasons • {totalEps} eps. • {juration.stringify(totalEps * tvShow.episodeLength)} ({juration.stringify(tvShow.episodeLength)}) • {tvShow.contentRating}
              </div>

              {/* <div>
                39 hours - Perfect for a month of weeknight bingeing
              </div> */}

              <div className="generalConsensus"
                style={{
                  borderColor: ratingColors[r].background,
                }}
              >
                <div className="answer"
                  style={{
                    color: ratingColors[r].background,
                  }}
                >
                  {didThisShowEndWell(tvShow)}
                </div>

                <div className="generalConsensusText"> {tvShow.generalConsensus}</div>


              </div>

              {/* <div className="generalConsensus">

                {[...Array(11)].map((_, i) => {
                  return (
                    <span className={`rating r-${i}`}>{i}</span>
                  )
                })}
              </div> */}

              <div className="webReviews">
                {reviewSources.map(x => {
                  const site = reviewSites.find(s => s._id == x.site);

                  let rating = 0;
                  if (site.usesAverage) {
                    let count = 0;
                    for (const season of tvShow.seasons) {
                      if (season.webReviews[x._id]?.rating) {
                        rating += season.webReviews[x._id].rating
                        count ++;
                      }
                    }
                    rating /= count;
                  }
                  else {
                    rating = tvShow.webReviews[x._id]?.rating ?? 0;
                  }
                  return (
                    <a href={tvShow.reviewSiteUrls[x.site]} target="_blank" className="webReview" key={x._id}>
                    <span className="site">{x.shortName}</span>
                    <span className="rating">{formatNumber(rating*10)}{/*  (240k) */}</span>
                  </a>
      
                  )
                })}


              </div>
            </div>
          </div>
          <div className="body-bottom">
            {/* <h3>Season Ratings</h3> */}


            <HighchartsReact
              highcharts={Highcharts}
              options={{
                chart: {
                  type: 'column',
                  backgroundColor: 'transparent',
                },
                title: {
                    text: null,
                    // align: 'left'
                },
                // subtitle: {
                //     text:
                //         'Source: <a target="_blank" ' +
                //         'href="https://www.indexmundi.com/agriculture/?commodity=corn">indexmundi</a>',
                //     align: 'left'
                // },
                xAxis: {
                    categories,
                    // crosshair: true,
                    // accessibility: {
                    //     description: 'Countries'
                    // }
                },
                yAxis: {
                    min: 0,
                    max: 10,
                    tickInterval: 1,
                    title: {
                        text: 'Rating'
                    }
                },
                // tooltip: {
                //     valueSuffix: ' (1000 MT)'
                // },
                plotOptions: {
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0
                    }
                },
                series,
                // series: [
                //   {
                //     name: 'IMDb',
                //     data: [8, 9, 9.6, 9.4]
                //   },
                //   {
                //     name: 'RT (Critics)',
                //     data: [9.1, 8.9, 9.2, 9.7]
                //   },
                //   {
                //     name: 'RT (Audience)',
                //     data: [9.1, 8.9, 9.2, 9.7]
                //   },
                //   {
                //     name: 'Metacritic',
                //     data: [9.1, 8.9, 9.2, 9.7]
                //   },

                // ]
              }}
            />
          </div>
        </div>
        <Footer />
      </>
    )
  }
}

@component
class Admin_TvShow extends Component<{ id }> {
  static styles = styled.div`
    tr {
      &:hover td {
        background-color: gray;
      }
    }
  `;

  tick = 0;
  render() {
    const tvShow = db.tvShows.findById(this.props.id);

    const webReviews = XObject.get(tvShow, 'webReviews', {});

    const reviewSiteUrls = XObject.get(tvShow, 'reviewSiteUrls', {});


    return (
      <>
        {tvShow.scrape && <button
          onClick={() => {
            tvShow.scrape = false;
          }}
        >Scraped</button>}
        <div>
          ID: {tvShow._id}
        </div>
        <Link target="_blank" to={`/${tvShow.slug}`}>Link</Link>
        <div>
          Name: <PropertyField object={tvShow} property="name" onBeforeChange={name => {
            tvShow.slug = _.kebabCase(name);
            // reviewSiteUrls[ReviewSite.rottenTomatoes] = 'https://www.rottentomatoes.com/tv/' + _.kebabCase(name).replace(/-/g, '_');
            // reviewSiteUrls[ReviewSite.metacritic] ='https://www.metacritic.com/tv/'+ _.kebabCase(name);

            ++ this.tick;
            this.forceUpdate();
          }} />
        </div>
        <div>
          Slug: <PropertyField object={tvShow} property="slug" />
        </div>
        <div>
          Start Date: <PropertyField object={tvShow} property="startDate" type="date" />
        </div>
        <div>
          End Date: <PropertyField object={tvShow} property="endDate" type="date" />
        </div>

        <div>
          Content Rating: <PropertyField object={tvShow} property="contentRating" />
        </div>
        <div>
          Episode Length: <PropertyField object={tvShow} property="episodeLength" type="duration" />
        </div>

        <div>
          Canceled: <PropertyField object={tvShow} property="canceled" type="bool" />
        </div>

        
        
        <Media value={tvShow.poster} setValue={v => tvShow.poster = v} />


        <div>
          General Consensus: <PropertyField object={tvShow} property="generalConsensus" /> <button
            onClick={async () =>{
              tvShow.generalConsensus = await clipboard.read();
            }}
          >.</button>
        </div>


        <div>
          General Consensus Rating: <PropertyField object={tvShow} property="generalConsensusRating" /> 

          {[...Array(10)].map((__, i) => {
            return <button
              onClick={() => {
                tvShow.generalConsensusRating = (i+1)/10;
              }}
            >{i + 1}</button>
          })}
        </div>

        <div>
          Unclear Answer: <PropertyField object={tvShow} property="unclearAnswer" type="bool" />
        </div>

        <div>
          Contentious: <PropertyField object={tvShow} property="contentious" type="bool" />
        </div>

        <button
          onClick={() => {
            copy(genPromp1(tvShow.name));
          }}
        >Copy 1</button>

<button
          onClick={() => {
            copy(genPrompt2());
          }}
        >Copy 2</button>

<button
            onClick={async () =>{
              tvShow.generalConsensus = await clipboard.read();
            }}
          >Paste</button>

        <table border={1} key={this.tick}>
          <thead>
            <tr>
              <th>Site</th>
              <th>URL</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {reviewSites.map(x => {
              return (
                <tr key={x._id}>
                  <td>{x.name}</td>
                  <td><input type="text" defaultValue={reviewSiteUrls[x._id]} onChange={e => reviewSiteUrls[x._id] = e.target.value} /></td>
                  <td><a target="_blank" href={reviewSiteUrls[x._id]}>#</a></td>
                  <td>
                    {x.search && <a target="_blank" href={x.search(tvShow.name)}>#</a>}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>


        <table border={1}>
          <thead>
            <tr>
              <th>#</th>
              <th>Eps.</th>
              {reviewSources.map(r => {
                return (
                  <th key={r._id}>
                    {r.shortName}
                  </th>
                )
              })}
              <th />
            </tr>
          </thead>
          <tbody>
            <tr>
              <td />
              <td />
              {reviewSources.map(r => {
                const rs = XObject.get(webReviews, r._id, {});
                return (
                  <td key={r._id}>
                    <input type="text" size={3} placeholder="Rating" defaultValue={rs.rating} onChange={e => rs.rating = parseFloat(e.target.value)} />
                    <input type="text" size={4} placeholder="Count" defaultValue={rs.count} onChange={e => rs.count = e.target.value} />
                  </td>
                )
              })}
            </tr>
            {tvShow.seasons?.map?.((s, i) => {
              const webReviews = XObject.get(s, 'webReviews', {});

              return (
                <tr key={s._id}>
                  <td>
                    <input type="text" size={2} placeholder="#" defaultValue={s.number} onChange={e => s.number = parseFloat(e.target.value)} />
                  </td>
                  <td>
                    <input type="text" size={2} placeholder="" defaultValue={s.numEpisodes} onChange={e => s.numEpisodes = parseInt(e.target.value)} />
                  </td>
                  {reviewSources.map(r => {
                    const rs = XObject.get(webReviews, r._id, {});
                    return (
                      <td key={r._id}>
                        <input type="text" size={3} placeholder="Rating" defaultValue={rs.rating} onChange={e => rs.rating = parseFloat(e.target.value)} />
                        <input type="text" size={4} placeholder="Count" defaultValue={rs.count} onChange={e => rs.count = e.target.value} />
                      </td>
                    )
                  })}
                  <td><button
                    onClick={() => {
                      tvShow.seasons.splice(i, 1);
                    }}
                  >X</button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <button
              onClick={() => {
                XObject.push(tvShow, 'seasons', XObject.obj());
              }}
            >+</button>
        {/* <ul>
          {tvShow.seasons?.map?.(s => {
            return <li key={s._id}>
              <div>
                Number: <PropertyField object={s} property="number" />
              </div>

            </li>
          })}
          <li>

          </li>
        </ul> */}

        <button
          onClick={() => {
            const index = db.tvShows.indexOf(tvShow);
            db.tvShows.splice(index, 1);
          }}
        >Delete</button>

<br  />
        <textarea
          style={{
            width: '500px',
            height: '200px',
          }}
          defaultValue={tvShow.notes}
          onChange={e => {
            tvShow.notes = e.target.value;
          }}
        >

        </textarea>
      </>
    )
  }
}


@component
class Users extends Component {
  render() {
    return (
      <>
        <ul>
          {db.users.map(x => {
            return (
              <li key={x._id}>
                <div>
                  Name: <PropertyField object={x} property="name" />
                </div>
                <div>
                  ID: {x._id}
                </div>
              </li>
            )
          })}
          <li>
            <button
              onClick={() => {
                db.users.push(XObject.obj());
              }}
            >+</button>
          </li>
        </ul>
      </>
    )
  }
}

@component
class Admin_Queue extends Component {
  static styles = styled.div`
    table {
      border-collapse: collapse;
      margin-top: 12px;
    }
    th, td {
      padding: 4px 10px;
      text-align: left;
      border-bottom: 1px solid #ddd;
      vertical-align: top;
      font-size: 13px;
    }
    .status-pending { color: #888; }
    .status-running { color: #0070f3; font-weight: bold; }
    .status-done    { color: #0a0; }
    .status-failed  { color: #c00; }
    .error {
      white-space: pre-wrap;
      font-family: monospace;
      font-size: 11px;
      color: #900;
      max-width: 420px;
    }
    .add-row input {
      padding: 4px 8px;
      margin-right: 6px;
      min-width: 240px;
    }
    .worker-state {
      display: inline-block;
      padding: 6px 10px;
      margin: 8px 0;
      border-radius: 4px;
      font-size: 13px;
    }
    .worker-state.running { background: #e6f7ea; color: #0a0; }
    .worker-state.paused  { background: #fff4e6; color: #b36b00; }
    .worker-state button { margin-left: 10px; }
  `;

  state = XInit(class {
    newName = '';
  });

  render() {
    const add = () => {
      const name = this.state.newName.trim();
      if (!name) return;
      const job = XObject.obj({
        name,
        status: 'pending',
        createdAt: new Date(),
      });
      db.scrapeQueue.push(job);
      this.state.newName = '';
    };

    const retry = (job) => {
      job.status = 'pending';
      job.error = '';
      job.startedAt = null;
      job.completedAt = null;
    };

    const remove = (job) => {
      const idx = db.scrapeQueue.findIndex(x => x._id === job._id);
      if (idx !== -1) db.scrapeQueue.splice(idx, 1);
    };

    const jobs = [...(db.scrapeQueue || [])].sort((a, b) => {
      const aT = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const bT = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return bT - aT;
    });

    const fmt = (d) => d ? new Date(d).toLocaleString() : '';

    const workerState = db.scrapeWorkerState?.[0];
    const paused = !!workerState?.paused;

    const togglePaused = () => {
      if (workerState) {
        workerState.paused = !workerState.paused;
      } else {
        // First-time toggle: lazily create the single state doc.
        db.scrapeWorkerState.push(XObject.obj({ paused: true }));
      }
    };

    return (
      <>
        <h2>Scrape Queue</h2>
        <div className={`worker-state ${paused ? 'paused' : 'running'}`}>
          Worker: <strong>{paused ? 'paused' : 'running'}</strong>
          <button onClick={togglePaused}>{paused ? 'Resume' : 'Pause'}</button>
        </div>
        <div className="add-row">
          <input
            placeholder="Show name"
            value={this.state.newName}
            onChange={e => this.state.newName = e.target.value}
            onKeyDown={e => { if (e.key === 'Enter') add(); }}
          />
          <button onClick={add}>Add to queue</button>
        </div>

        {jobs.length === 0 ? <p>No jobs.</p> : (
          <table>
            <thead>
              <tr>
                <th>Show</th>
                <th>Status</th>
                <th>Added</th>
                <th>Started</th>
                <th>Finished</th>
                <th>Error</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {jobs.map(job => (
                <tr key={job._id}>
                  <td><Link to={`/${_.kebabCase(job.name)}`} target="_blank">{job.name}</Link></td>
                  <td className={`status-${job.status}`}>{job.status}</td>
                  <td>{fmt(job.createdAt)}</td>
                  <td>{fmt(job.startedAt)}</td>
                  <td>{fmt(job.completedAt)}</td>
                  <td className="error">{job.error || ''}</td>
                  <td>
                    {job.status === 'failed' && <button onClick={() => retry(job)}>Retry</button>}
                    {job.status !== 'running' && <button onClick={() => remove(job)}>Delete</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </>
    );
  }
}

function averageRating(tvShow) {
  let rating = 0;
  const ratings = seasonAverages(tvShow);
  for (const r of ratings) {
    rating += r;
  }
  rating /= ratings.length;
  return rating;

}

@component
class TvShows extends Component {
  static styles = styled.div`
    .body {
      max-width: 880px;
      margin: 0 auto;
      padding-bottom: 32px;

      @media (max-width: calc(879px + 16px*2)) {

        padding-left: 16px;
        padding-right: 16px;
      }

      @media (max-width: 769px) {
        .tvShows {
          grid-template-columns: 1fr 1fr !important;


        }
      }

      @media (max-width: 546px) {
        .tvShows {
          grid-template-columns: 1fr !important;

          .tvShow {
            height: auto !important;
          }


        }
      }

      .controls {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
        margin-bottom: 16px;
        font-size: 13px;

        > input, select, button {
          font: inherit;
          padding: 6px 8px;
          border: 1px solid rgba(0,0,0,.2);
          border-radius: 4px;
          background: white;
          color: inherit;
          box-sizing: border-box;
        }

        > input[type="number"] {
          width: 72px;
        }

        .search {
          flex: 1 1 180px;
          min-width: 140px;
        }

        button {
          cursor: pointer;
        }

        button:disabled {
          opacity: .4;
          cursor: default;
        }

        .dir {
          width: 32px;
          padding: 6px 0;
          text-align: center;
        }

        .clear {
          background: transparent;
          border-color: transparent;
          text-decoration: underline;
          padding-left: 4px;
          padding-right: 4px;
        }

        .rangeSlider {
          display: flex;
          align-items: center;
          gap: 8px;

          .label {
            color: rgba(0,0,0,.6);
          }

          .value {
            color: rgba(0,0,0,.75);
            min-width: 36px;
            text-align: right;
            font-variant-numeric: tabular-nums;
          }

          .slider {
            position: relative;
            width: 140px;
            height: 24px;
            display: flex;
            align-items: center;
          }

          .track {
            position: absolute;
            left: 0;
            right: 0;
            height: 4px;
            background: rgba(0,0,0,.15);
            border-radius: 2px;
          }

          .range {
            position: absolute;
            height: 4px;
            background: rgba(0,0,0,.55);
            border-radius: 2px;
          }

          input[type="range"] {
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            height: 24px;
            margin: 0;
            padding: 0;
            background: transparent;
            border: none;
            pointer-events: none;
            -webkit-appearance: none;
            appearance: none;
          }

          input[type="range"]::-webkit-slider-runnable-track {
            background: transparent;
            border: none;
          }
          input[type="range"]::-moz-range-track {
            background: transparent;
            border: none;
          }

          input[type="range"]::-webkit-slider-thumb {
            pointer-events: auto;
            -webkit-appearance: none;
            appearance: none;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: white;
            border: 1px solid rgba(0,0,0,.45);
            box-shadow: 0 1px 2px rgba(0,0,0,.2);
            cursor: pointer;
            margin-top: 0;
          }
          input[type="range"]::-moz-range-thumb {
            pointer-events: auto;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: white;
            border: 1px solid rgba(0,0,0,.45);
            box-shadow: 0 1px 2px rgba(0,0,0,.2);
            cursor: pointer;
          }
        }
      }

      .tvShows {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr; /* Creates 3 equal-width columns */
        gap: 16px; /* Defines the gap between grid items */


        .tvShow {
          background-color: rgb(255 251 245);

          ${TvShowSparkline} {
            margin-top: 8px;
          }
          transition: box-shadow linear 100ms;
          &:hover {
            box-shadow: 0 2px 16px rgba(0,0,0,.32);
          }
          text-decoration: none;
          color: inherit;
          /* border: 1px solid black; */
          box-shadow: 0 0.125rem 1rem rgba(0,0,0,.08);
          position: relative;
          height: calc(132px + 12px*2);
          padding: 12px;
          box-sizing: border-box;
          padding-left: calc(88px + 12px + 8px);
          border-radius: 4px;

          ${styles}

          &.canceled {
            .name {
              text-decoration: line-through;
            }
          }

          .markWatched {
            position: absolute;
            top: 8px;
            right: 8px;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: rgba(255, 255, 255, .9);
            border: 1px solid rgba(0, 0, 0, .25);
            color: rgba(0, 0, 0, .5);
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            cursor: pointer;
            user-select: none;
            z-index: 2;
            opacity: 0;
            transition: opacity 100ms, background 100ms, color 100ms;

            &:hover {
              background: white;
              color: black;
            }

            &.on {
              opacity: 1;
              background: #2e7d32;
              border-color: #2e7d32;
              color: white;
            }
          }

          &:hover .markWatched {
            opacity: 1;
          }



          .name {
            font-weight: bold;
            display:block;
            margin-bottom: 2px;
          }

          .stats {
            font-size: 9px;
            margin-bottom: 6px;
          }

          .consensus {
            /* font-size: 10px; */
            font-size: 10px;

            .answer {
              font-weight: bold;
              margin-left: 2px;
            }

            .genConsensusRating {
              transform: scale(.8);
            }

          }


          .poster {
            width: 88px;
            height: 132px;
            position: absolute;
            top: 12px;
            left: 12px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 4px;
            overflow: hidden;
          }

        }
      }
    }
  `;
  state = XInit(class {
    search = '';
    seasonsLo: number = 1;
    seasonsHi: number = 999;
    ratingLo: number = 0;
    ratingHi: number = 10;
    sortBy: 'default' | 'name' | 'rating' | 'seasons' | 'startDate' | 'endDate' = 'default';
    sortDir: 'asc' | 'desc' = 'desc';
    view: 'grouped' | 'flat' = 'grouped';
    watchedFilter: 'all' | 'unwatched' | 'watched' = 'all';
    watched: { [id: string]: boolean } = {};
  })

  static STORAGE_KEY = 'tvShowsListFilters';
  static WATCHED_KEY = 'tvShowsWatched';

  componentDidMount(): void {
    document.title = 'Did This Show End Well?';
    try {
      const raw = localStorage.getItem(TvShows.STORAGE_KEY);
      if (raw) {
        const saved = JSON.parse(raw);
        if (saved && typeof saved === 'object') {
          for (const k of ['search', 'seasonsLo', 'seasonsHi', 'ratingLo', 'ratingHi', 'sortBy', 'sortDir', 'view', 'watchedFilter']) {
            if (k in saved) this.state[k] = saved[k];
          }
        }
      }
    } catch (e) {
      // ignore malformed storage
    }
    try {
      const rawW = localStorage.getItem(TvShows.WATCHED_KEY);
      if (rawW) {
        const saved = JSON.parse(rawW);
        if (saved && typeof saved === 'object') {
          this.state.watched = saved;
        }
      }
    } catch (e) {
      // ignore malformed storage
    }
  }

  persist = () => {
    try {
      const s = this.state;
      localStorage.setItem(TvShows.STORAGE_KEY, JSON.stringify({
        search: s.search,
        seasonsLo: s.seasonsLo,
        seasonsHi: s.seasonsHi,
        ratingLo: s.ratingLo,
        ratingHi: s.ratingHi,
        sortBy: s.sortBy,
        sortDir: s.sortDir,
        view: s.view,
        watchedFilter: s.watchedFilter,
      }));
    } catch (e) {
      // ignore quota / unavailable
    }
  }

  persistWatched = () => {
    try {
      localStorage.setItem(TvShows.WATCHED_KEY, JSON.stringify(this.state.watched));
    } catch (e) {
      // ignore quota / unavailable
    }
  }

  toggleWatched = (id: string) => {
    const next = { ...this.state.watched };
    if (next[id]) delete next[id];
    else next[id] = true;
    this.state.watched = next;
    this.persistWatched();
  }

  clearFilters = () => {
    this.state.search = '';
    this.state.seasonsLo = 1;
    this.state.seasonsHi = 999;
    this.state.ratingLo = 0;
    this.state.ratingHi = 10;
    this.state.sortBy = 'default';
    this.state.sortDir = 'desc';
    this.state.view = 'grouped';
    this.state.watchedFilter = 'all';
    this.persist();
  }

  render() {
    const { search, seasonsLo, seasonsHi, ratingLo, ratingHi, sortBy, sortDir, view, watchedFilter, watched } = this.state;

    const baseList = db.tvShows.filter(s => s.seasons && s.generalConsensus);

    // Dynamic upper bound for the seasons slider, from the data itself.
    const dataMaxSeasons = Math.max(1, ...baseList.map(s => s.seasons.length));
    const seasonsMin = 1;
    const seasonsMax = Math.max(seasonsMin + 1, dataMaxSeasons);
    const seasonsDispLo = Math.min(Math.max(seasonsLo, seasonsMin), seasonsMax);
    const seasonsDispHi = Math.min(Math.max(seasonsHi, seasonsMin), seasonsMax);
    const seasonsFilterActive = seasonsDispLo > seasonsMin || seasonsDispHi < seasonsMax;

    // Rating slider: fixed 0–10 scale.
    const ratingMin = 0;
    const ratingMax = 10;
    const ratingDispLo = Math.min(Math.max(ratingLo, ratingMin), ratingMax);
    const ratingDispHi = Math.min(Math.max(ratingHi, ratingMin), ratingMax);
    const ratingFilterActive = ratingDispLo > ratingMin || ratingDispHi < ratingMax;

    let filtered = baseList;

    if (search.trim()) {
      const q = search.trim().toLowerCase();
      filtered = filtered.filter(s => s.name && s.name.toLowerCase().includes(q));
    }
    if (seasonsFilterActive) {
      filtered = filtered.filter(s => s.seasons.length >= seasonsDispLo && s.seasons.length <= seasonsDispHi);
    }
    if (ratingFilterActive) {
      filtered = filtered.filter(s => {
        const r = s.generalConsensusRating * 10;
        return r >= ratingDispLo && r <= ratingDispHi;
      });
    }
    if (watchedFilter === 'unwatched') {
      filtered = filtered.filter(s => !watched[s._id]);
    } else if (watchedFilter === 'watched') {
      filtered = filtered.filter(s => !!watched[s._id]);
    }

    if (sortBy !== 'default') {
      const dir = sortDir === 'asc' ? 1 : -1;
      filtered = [...filtered].sort((a, b) => {
        switch (sortBy) {
          case 'name':
            return (a.name || '').localeCompare(b.name || '') * dir;
          case 'rating':
            return ((a.generalConsensusRating || 0) - (b.generalConsensusRating || 0)) * dir;
          case 'seasons':
            return (a.seasons.length - b.seasons.length) * dir;
          case 'startDate': {
            const at = a.startDate ? a.startDate.getTime() : 0;
            const bt = b.startDate ? b.startDate.getTime() : 0;
            return (at - bt) * dir;
          }
          case 'endDate': {
            const at = a.endDate ? a.endDate.getTime() : 0;
            const bt = b.endDate ? b.endDate.getTime() : 0;
            return (at - bt) * dir;
          }
          default:
            return 0;
        }
      });
    }

    const endedWell = filtered.filter(tvShow => tvShow.generalConsensusRating > .6);
    const endedAveragely = filtered.filter(tvShow => tvShow.generalConsensusRating == .6);
    const endedPoorly = filtered.filter(tvShow => tvShow.generalConsensusRating < .6);


    const render = tvShows => {
      return (
        <div className="tvShows">
          {tvShows.map(tvShow => {
            if (!tvShow.seasons) return;  
            const r = Math.round(tvShow.generalConsensusRating*10);
            let totalEps = 0;
            const rating = tvShow.averageRating;
            if (tvShow.seasons) {
              for (const s of tvShow.seasons) {
                totalEps += s.numEpisodes;
              }
            }
            

            const isWatched = !!watched[tvShow._id];
            return (
              <Link className={classNames("tvShow", { canceled: tvShow.canceled, watched: isWatched })} to={`/${tvShow.slug}`}>
                <span
                  className={classNames("markWatched", { on: isWatched })}
                  role="button"
                  title={isWatched ? 'Mark as unwatched' : 'Mark as watched'}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.toggleWatched(tvShow._id);
                  }}
                >
                  {isWatched ? '✓' : '+'}
                </span>
                <span className="poster" style={{
                  backgroundImage: `url(${uploadedFileUrl(tvShow.poster)})`,
                }} />
                <span className="name">{tvShow.name}</span>
                <div className="stats">
                  {tvShow.startDate.format('{yyyy}')}-{tvShow.endDate.format('{yyyy}')} • {tvShow.seasons.length} seasons • {totalEps} eps. • {juration.stringify(totalEps * tvShow.episodeLength)} ({juration.stringify(tvShow.episodeLength)}) • {tvShow.contentRating}
                </div>

                <div className="consensus">
                  <span className={classNames('genConsensusRating', `r-${r}`)}>{r}</span> 

                  <span className="answer">
                    {didThisShowEndWell(tvShow)}
                  </span>

                &nbsp;• {formatNumber(rating*10)}
                </div>

                <TvShowSparkline tvShow={tvShow} />
              </Link>
            )
          })}
        </div>
      );
    }
    return (
      <>
        <Header/>
        <div className="body">
          <div className="controls">
            <input
              className="search"
              type="text"
              placeholder="Search name…"
              value={search}
              onChange={e => { this.state.search = e.target.value; this.persist(); }}
            />
            <div className="rangeSlider" title={`Seasons: ${seasonsDispLo}–${seasonsDispHi}`}>
              <span className="label">Seasons</span>
              <div className="slider">
                <div className="track" />
                <div
                  className="range"
                  style={{
                    left: `${((seasonsDispLo - seasonsMin) / (seasonsMax - seasonsMin)) * 100}%`,
                    right: `${100 - ((seasonsDispHi - seasonsMin) / (seasonsMax - seasonsMin)) * 100}%`,
                  }}
                />
                <input
                  type="range"
                  min={seasonsMin}
                  max={seasonsMax}
                  step={1}
                  value={seasonsDispLo}
                  onChange={e => {
                    const v = Number(e.target.value);
                    this.state.seasonsLo = Math.min(v, this.state.seasonsHi);
                    this.persist();
                  }}
                />
                <input
                  type="range"
                  min={seasonsMin}
                  max={seasonsMax}
                  step={1}
                  value={seasonsDispHi}
                  onChange={e => {
                    const v = Number(e.target.value);
                    this.state.seasonsHi = Math.max(v, this.state.seasonsLo);
                    this.persist();
                  }}
                />
              </div>
              <span className="value">{seasonsDispLo}–{seasonsDispHi}</span>
            </div>
            <div className="rangeSlider" title={`Rating: ${ratingDispLo}–${ratingDispHi}`}>
              <span className="label">Rating</span>
              <div className="slider">
                <div className="track" />
                <div
                  className="range"
                  style={{
                    left: `${((ratingDispLo - ratingMin) / (ratingMax - ratingMin)) * 100}%`,
                    right: `${100 - ((ratingDispHi - ratingMin) / (ratingMax - ratingMin)) * 100}%`,
                  }}
                />
                <input
                  type="range"
                  min={ratingMin}
                  max={ratingMax}
                  step={1}
                  value={ratingDispLo}
                  onChange={e => {
                    const v = Number(e.target.value);
                    this.state.ratingLo = Math.min(v, this.state.ratingHi);
                    this.persist();
                  }}
                />
                <input
                  type="range"
                  min={ratingMin}
                  max={ratingMax}
                  step={1}
                  value={ratingDispHi}
                  onChange={e => {
                    const v = Number(e.target.value);
                    this.state.ratingHi = Math.max(v, this.state.ratingLo);
                    this.persist();
                  }}
                />
              </div>
              <span className="value">{ratingDispLo}–{ratingDispHi}</span>
            </div>
            <select
              value={sortBy}
              onChange={e => { this.state.sortBy = e.target.value as any; this.persist(); }}
            >
              <option value="default">Sort: Default</option>
              <option value="name">Name</option>
              <option value="rating">Rating</option>
              <option value="seasons">Seasons</option>
              <option value="startDate">Start date</option>
              <option value="endDate">End date</option>
            </select>
            <button
              className="dir"
              disabled={sortBy === 'default'}
              title={sortDir === 'asc' ? 'Ascending' : 'Descending'}
              onClick={() => { this.state.sortDir = sortDir === 'asc' ? 'desc' : 'asc'; this.persist(); }}
            >
              {sortDir === 'asc' ? '↑' : '↓'}
            </button>
            <select
              value={view}
              onChange={e => { this.state.view = e.target.value as any; this.persist(); }}
            >
              <option value="grouped">View: Grouped</option>
              <option value="flat">View: Flat</option>
            </select>
            <select
              value={watchedFilter}
              onChange={e => { this.state.watchedFilter = e.target.value as any; this.persist(); }}
            >
              <option value="all">All shows</option>
              <option value="unwatched">Unwatched</option>
              <option value="watched">Watched</option>
            </select>
            <button className="clear" onClick={this.clearFilters}>Clear</button>
          </div>

          {view === 'grouped' ? (
            <>
              {endedWell.length > 0 && <><h2>Ended Well</h2>{render(endedWell)}</>}
              {endedAveragely.length > 0 && <><h2>Just Okay</h2>{render(endedAveragely)}</>}
              {endedPoorly.length > 0 && <><h2>Ended Poorly</h2>{render(endedPoorly)}</>}
            </>
          ) : (
            render(filtered)
          )}
        </div>
        <Footer />
      </>
    )
  }
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <TvShows />,

  },
  {
    path: '/admin/tv-shows',
    Component: () => {
      const navigate = useNavigate();
      return <Admin_TvShows navigate={navigate} />;
    },
  },
  {
    path: '/admin/users',
    element: <Users />,
  },
  {
    path: '/admin/queue',
    element: <Admin_Queue />,
  },
  {
    path: '/admin',
    element: (
      <>
        <ul>
          <li><Link to="/admin/tv-shows">TV Shows</Link></li>
          <li><Link to="/admin/users">Users</Link></li>
          <li><Link to="/admin/queue">Queue</Link></li>
        </ul>
      </>
    )
  },
  {
    path: '/admin/tv-shows/:id',
    Component: () => {
      const { id } = useParams();
      return <Admin_TvShow id={id} />
    }
  },
  {
    path: '/tv-shows',
    element: <TvShows />,
  },

  {
    path: '/:slug',
    Component: () => {
      const { slug } = useParams();

      return <TvShow slug={slug} />;
    }
  },
]);

@component
class App extends Component {
  static styles = styled.div`

  `;

  state = XInit(class {
    loaded = false;
  })

  async componentDidMount() {
    if (config.s3) {
      const data = eval(`(${(await axios.get('https://doesthisshowendwell.s3.amazonaws.com/data.json')).data})`);
      initLocalDb(data);
  
    }
    else {
      await initDb([
        'tvShows',
        'users',
        'scrapeQueue',
        'scrapeWorkerState',
      ])
  
    }
    this.state.loaded = true;
    this.forceUpdate();
  }

  render() {
    if (!this.state.loaded) return;
    return (
      <>
        <RouterProvider router={router} />

        {/* <button
          onClick={() => {
            db.tvShows.push(XObject.obj({
              name: 'Test',
            }))
          }}
        >adsf</button> */}
      </>
    )
  }
}

export default App;
